import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import auth from './modules/auth'
import salesOrder from './modules/salesOrder'
import timeEntry from './modules/timeEntry'
import billing from './modules/billing'
import regie from './modules/regie'
import billingList from './modules/billingList'
import call from './modules/call'
import planner from './modules/planner'
import materialorder from './modules/materialorder'
import VuexPersist from 'vuex-persist'
import localforage from 'localforage'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const salesOrderStorage = new VuexPersist({
  key: 'salesOrderStorage',
  storage: localforage,
  modules: ['salesOrder']
})

const userSettingsStorage = new VuexPersist({
  key: 'userSettingsStorage',
  storage: window.localStorage,
  modules: ['user']
})

export default new Vuex.Store({
  modules: {
    user,
    auth,
    salesOrder,
    timeEntry,
    billing,
    regie,
    billingList,
    call,
    planner,
    materialorder
  },
  plugins: [salesOrderStorage.plugin, userSettingsStorage.plugin],
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js